/**
 * Why a stop is not on the map, in the words the office would use.
 *
 * ⭐ It lives in shared because TWO screens now draw the same day and must give the same
 * answer about the same address: `/fleet`'s routes map (112) and `/schedule`'s dispatch map
 * (114). It was a private const in `services/fleet.ts`, which was correct while one screen
 * asked — a second screen writing its own sentences is the "two sources that agree until
 * they don't" failure, and the drift would be invisible because both readings are plausible
 * English about the same row.
 *
 * ⚠️ The three cases are NOT the same kind of fact, which is why one sentence would be
 * wrong for all of them. `not_found` is a permanent answer about that text and the sweep
 * will never ask again; `failed` is a network blip that WILL be retried; `null` means nobody
 * has looked yet. Collapsing them to "no location" would tell a dispatcher to fix an address
 * that is fine, or to wait for a retry that is never coming.
 */
export function whyUnplaced(geocodeStatus: string | null): string {
  return geocodeStatus === 'not_found'
    ? "We couldn't find this address"
    : geocodeStatus === 'failed'
      ? 'The address lookup failed — it will try again'
      : 'Not looked up yet';
}
